module.exports = "//public.getcloudapp.com/packs/media/images/zight-favicon-66c070ab98d05e31306788c566bf99d0.png";